<template>
    <div>
        <a-drawer placement="right" :closable="false" :visible="visible" width="700"
            :after-visible-change="afterVisibleChange" @close="onClose" wrapClassName="drawClass">
            <div style="width:100%;height:100%">
                <div class="header">
                    <a-space :size="size">
                        <span><img src="../../assets/video/id.png" alt="" width="15">{{detailssnum.id}}</span>
<!--                        <span><img src="../../assets/video/渠道.png" alt="" width="15">渠道分发</span>-->
                        <!-- <a-tag color="blue">
                            3个
                        </a-tag> -->
                    </a-space>
                    <!-- <a-space :size="size">
                        <a-button>删除</a-button>
                        <a-button type="primary">编辑</a-button>
                    </a-space> -->
                </div>
                <div class="content" >
                    <div class="source" style=" height:calc(100% - 100px);">
                        <h3 style="text-align:center">{{detailssnum.title}}</h3>
                        <div class="vsource">
<!--                            <span v-if="detailssnum.isOriginal == 0" style="margin-right:10px;">原创</span>-->
<!--                            <span v-if="detailssnum.isOriginal == 1">来源：{{detailssnum.originalTitle}}</span>-->
                            <span>编辑：{{detailssnum.editor}}</span>
                        </div>
                      <div class="guide">
                        <div class="imgbg">
                          <vuescroll
                              ref="vs"
                          >
                            <h1 style="font-size: 16px;text-align:left;line-height: 1.36em;
                              word-break: break-all;
                              color: #333;
                              padding: 0 15px;
                              margin-top: 10px;">
                              {{detailssnum.title}}</h1>
                            <div class="rmh-info">
                              <div class="photo">
                                <img :src="subscribe.logoUrl" width="100%" alt=""/>
                              </div>
                              <div class="name-info">
                                <div class="name">{{subscribe.name}}</div>
                                <div class="des-info">{{formatDate(detailssnum.updateAt)}}</div>
                              </div>
                            </div>
<!--                            <h5 style="text-align: left;padding-left: 5px;padding-right: 5px">{{formatDate(detailssnum.updateAt)}}</h5>-->
<!--                            <div v-if="content==null||content==''"><a-empty style="margin: 50% auto"/></div>-->

<!--                            <div v-else-if="content!=''||content!=null"  v-html="content" class="article"></div>-->
<!--                            <div v-else><a-empty style="margin: 50% auto"/></div>-->
                            <a-spin :spinning="spinning" v-if="content==null||content==''">
                              <div ><a-empty style="margin: 10% auto"/></div>
                            </a-spin>
                            <div v-else-if="content!=''||content!=null" v-html="content" class="article"></div>
                            <div v-else><a-empty style="margin: 10% auto"/></div>
                            <h5 style="text-align: left;padding-left: 15px;padding-right: 15px;margin-bottom: 1rem">
                              <p style="font-size: 12px;line-height: 24px">
                                <span v-if="detailssnum.editor"  style="color: #CCCCCC;margin-right: 8px">编辑:</span>
                                <span v-if="detailssnum.editor">{{detailssnum.editor}}</span>
                              </p>
                              <p style="font-size: 12px;line-height: 24px">
                                <span v-if="detailssnum.reporter" style="color: #CCCCCC;margin-right: 8px">记者:</span>
                                <span v-if="detailssnum.reporter">{{detailssnum.reporter}}</span>
                              </p>
                            </h5>
                          </vuescroll>

                        </div>
                      </div>
<!--                        <a-spin :spinning="spinning" v-if="content==null||content==''">-->
<!--                          <div ><a-empty style="margin: 10% auto"/></div>-->
<!--                        </a-spin>-->
<!--                        <div v-else-if="content!=''||content!=null" v-html="content"></div>-->
<!--                        <div v-else><a-empty style="margin: 10% auto"/></div>-->
<!--                        <div v-if="detailssnum.type == 2" style="margin-top:10px;">-->
<!--                            <a-carousel autoplay>-->
<!--                                <div v-for="(e,i) in detailssnum.content" :key="i">-->
<!--                                    <img style="width:100%;" :src="e.imageUrl">-->
<!--                                    <p style="text-align:center;">{{e.imageDesc}}</p>-->
<!--                                </div>-->
<!--                            </a-carousel>-->
<!--                        </div>-->

<!--                        <div v-if="detailssnum.type == 3" style="margin-top:10px;">-->
<!--                            <video autoplay loop muted style="width:100%;">-->
<!--                                <source :src="detailssnum.videoPath" type="video/mp4" />-->
<!--                            </video>-->
<!--                            <p>{{detailssnum.videoDesc}}</p>-->
<!--                        </div>-->

<!--                        <div v-if="detailssnum.type == 4" style="margin-top:10px;">-->
<!--                            <a :href="detailssnum.linkUrl">{{detailssnum.linkUrl}}</a>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </a-drawer>
    </div>
</template>
<script>
import vuescroll from 'vuescroll';
import { getArticleInfo } from '@/api/article'
    export default {
        name: "detail-drawer",
        props:['detailssnum'],
      components:{vuescroll},
        data() {
            return {
              spinning:false,
                visible: true,
                size: 'small',
                list:[],
              content:'',
              subscribe:{
                logoUrl:'',
                name:''
              }
            }
        },
        mounted() {},
        destroyed() {},
        methods: {
            afterVisibleChange(val) {
                console.log('visible', val);
            },
            showDrawer() {
                this.visible = true;
            },
            onClose() {
                this.visible = false;
                this.$emit("visible", this.visible)
            },
            getContent(){
              this.spinning=true
              getArticleInfo({id:this.detailssnum.id}).then(res=>{
                if(res.status){
                  this.content=res.data.content
                  this.spinning=false
                }
              })
            },
          //时间戳转换
          formatDate(value) {
            var date = new Date(value * 1000);
            var y = date.getFullYear(),
                m = date.getMonth() + 1,
                d = date.getDate(),
                h = date.getHours(),
                i = date.getMinutes(),
                s = date.getSeconds();
            if (m < 10) { m = '0' + m; }
            if (d < 10) { d = '0' + d; }
            if (h < 10) { h = '0' + h; }
            if (i < 10) { i = '0' + i; }
            if (s < 10) { s = '0' + s; }
            var t = y + '-' + m + '-' + d + ' ' + h + ':' + i + ':' + s;
            return t;

          },

        },
        watch: {
        },
        created() {
          this.getContent()
          this.subscribe=JSON.parse(sessionStorage.getItem('subscribe'))
        }
    }
</script>

<style lang="scss" scoped>
    /deep/.ant-drawer-body {
        padding: 0;
    }
    .header {
        padding: 10px 30px 20px 30px;
        display: flex;
        cursor: pointer;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ECECEC;
        background: #fff;
        position: sticky;
        top: 0;

        /deep/.ant-btn {
            padding: 0 25px;
        }

        span {
            display: flex;
            align-items: center;

            img {
                margin-right: 5px;
            }
        }
    }
    .content {
        width: 100%;
        height: 100%;
        padding: 22px 60px;
        overflow: auto;
        .source {
            margin: 0 auto;
            h3 {
                font-size: 20px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
            }
            .vsource {
                margin-top: 8px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
            }
            p {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                line-height: 28px;
            }
        }
    }
    .guide{
      margin: 5% auto;
      //margin-left: 25%;
      padding: 20px 20px;
      text-align: center;
      width: 33vh;

      .imgbg{
        width: 100%;
        height: 60vh;
        box-shadow: 0px 4px 16px 1px rgba(0, 0, 0, 0.550000011920929);
        border-radius: 47px 47px 47px 47px;
        opacity: 1;
        border: 10px solid #464347;
        position: relative;
        overflow: hidden;
        padding-top: 10px;
        //padding: 5px 5px;
        .article{
          padding: 5px 15px;
          width: 100%;
          /deep/ p{
            font-size: 12px!important;
            //text-indent: 24px;
            text-align: left;
            //margin-bottom: 1rem;
          }
          /deep/div{
            font-size: 12px!important;
            //text-indent: 24px;
            text-align: left;
          }
          /deep/ img{
            max-width: 95%;
          }
        }
        //修改文章内容宽度
        /deep/ .__view{
          width: auto!important;
        }
        .rmh-info{
          margin-top: 16px;
          margin-bottom: 16px;
          padding: 0 15px;
          position: relative;
          display: -webkit-box;
          display: -webkit-flex;
          display: -ms-flexbox;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -ms-flex-align: center;
          align-items: center;
          .photo{
            width: 36px;
            height: 36px;
            overflow: hidden;
          }
          .name-info{
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -ms-flex: 1;
            flex: 1;
            width: 100px;
            padding-left: 10px;
            text-align: left;
            .name{
              max-width: 100%;
              height: 20px;
              font-size: 12px;
              color: #333;
              letter-spacing: 0;
              line-height: 20px;
              font-weight: 700;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .des-info{
              padding-top: 1px;
              font-size: 12px;
              color: #999;
              letter-spacing: 0;
              height: 17px;
              line-height: 17px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
</style>